<template>
    <div class="faq container">
        <div class="search">
            <form action="#" @submit.prevent="search()">
                <input v-model="fields.search" type="text" :placeholder="trans.search" />
                <button aria-label="Search" type="submit" class="button button-big">
                    <i class="fa fa-search"></i>
                </button>
            </form>
        </div>

        <div class="list" v-for="(category, i) in itemsList">
            <h2>{{ category.name }}</h2>

            <faq-item v-for="(question, j) in category.questions" :key="(i + j)" :question="question"></faq-item>
        </div>
        <alert v-if="itemsList.length < 1" type="error" :message="trans.messages.no_items"></alert>
    </div>
</template>

<style lang="scss" scoped>
    .faq {
        max-width: 800px;
    }

    form {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 24px;

        button {
            margin-left: 8px;
        }
    }

    h2 {
        margin-top: 32px;
    }
</style>

<script>
    import FaqItem from './FaqItem.vue'
    import Alert from '../form/AlertForm.vue'

    export default {
        props: {
            list: {
                type: Array,
                required: true,
            },
            trans: {
                type: Object,
                required: true,
            },
        },

        components: {
            FaqItem, Alert
        },

        data() {
            return {
                itemsList: this.list,
                fields: {
                    search: ''
                }
            }
        },

        methods: {
            search() {
                const search = this.fields.search.toLowerCase()
                const list = this.unobserve(this.list)

                if (search.trim === '') {
                    this.itemsList = this.list
                    return true
                }

                this.itemsList = list.map(item => {
                    const questionsMatches = item.questions.filter(questionItem => {
                        const answer = questionItem.answer.toLowerCase()
                        const question = questionItem.question.toLowerCase()

                        return question.includes(search) || answer.includes(search)
                    })

                    if (questionsMatches.length > 0) {
                        item.questions = questionsMatches
                        return item
                    }

                    return false
                }).filter(item => !!item)
            },

            unobserve(obj) {
                // Workaround to disable Vue observation
                // @see https://github.com/vuejs/vue/issues/2637#issuecomment-321659236
                return JSON.parse(JSON.stringify(obj))
            }
        },
    }
</script>
